import httpService from './httpService';

export enum ScoreCardType {
  COUNT = 'COUNT',
  GRADE = 'GRADE',
  TIME_HH_MM = 'TIME_HH_MM',
  TIME_MM_SS = 'TIME_MM_SS',
  TIME_HH_MM_SS = 'TIME_HH_MM_SS',
  PERCENTAGE = 'PERCENTAGE',
  BOOLEAN = 'BOOLEAN',
}

export interface ScoreCardScoreModel {
  scoreCardId?: number;
  memberId: number;
  score: number;
  lastUpdated: string | Date;
  firstName?: string;
  lastName?: string;
  userId?: number;
  picture?: string;
  type?: ScoreCardType;
}

export interface ScoreCard {
  scoreCardId: number;
  communityId: number;
  name: string;
  description?: string;
  picture?: string;
  memberEditAccess: boolean;
  containsAllMembers: boolean;
  selectedUserIds?: number[];
  lastUpdated: string | Date;
  ascending: boolean;
  type: ScoreCardType;
  scores: ScoreCardScoreModel[];
  totalScore: number;
}

export type ScoreCardCreateInfo = {
  communityId: number;
  name: string;
  description?: string;
  memberEditAccess: boolean;
  containsAllMembers: boolean;
  selectedUserIds?: number[];
  ascending?: boolean;
  type: ScoreCardType;
};

export type ScoreCardUpdateInfo = Partial<
  Pick<ScoreCard, 'name' | 'description' | 'memberEditAccess' | 'containsAllMembers' | 'ascending'>
>;

export type GetAllScoreCardsResponse = ScoreCard[];

export async function getAllScoreCards(communityId: number): Promise<GetAllScoreCardsResponse> {
  return httpService
    .get<GetAllScoreCardsResponse>(`/networks/communities/${communityId}/score-cards`)
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export async function updateScoreCardScores(
  communityId: number,
  scoreCardId: number,
  scores: { memberId: number; score: number }[],
): Promise<void> {
  const body = { scores };

  return httpService
    .put(`/networks/communities/${communityId}/score-cards/${scoreCardId}/scores`, body)
    .then(() => undefined)
    .catch((err) => {
      if (err.response?.status === 401) {
        throw new Error('UNAUTHORIZED');
      }
      throw err;
    });
}

export async function createScoreCard(data: ScoreCardCreateInfo): Promise<ScoreCard> {
  return httpService
    .post<ScoreCard>(`/networks/communities/${data.communityId}/score-cards/`, data)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response?.status === 401) throw new Error('UNAUTHORIZED');
      throw err;
    });
}

export async function updateScoreCard(
  communityId: number,
  scoreCardId: number,
  updates: ScoreCardUpdateInfo,
): Promise<void> {
  return httpService
    .put(`/networks/communities/${communityId}/score-cards/${scoreCardId}`, updates)
    .then(() => undefined)
    .catch((err) => {
      if (err.response?.status === 401) throw new Error('UNAUTHORIZED');
      throw err;
    });
}

export default {
  getAllScoreCards,
  updateScoreCardScores,
  createScoreCard,
};
